module.exports = __webpack_public_path__ + "img/title.d7e9c619.png";